export default {
    PHYSICAL: 1,
    MAILING: 2,
    BILLING: 3,
    PREVIOUS: 4,
    1: 'Physical',
    2: 'Mailing',
    3: 'Billing',
    4: 'Previous'
};